import React, { useCallback, useState } from "react";
import styles from "./category.module.scss";
import {
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoText,
  KoTextArea,
  KoToast,
  Upload
} from "packages";
import ImgCrop from "antd-img-crop";
import KoIcon from "@kwapio/icons";
import { getCookie } from "shared/utils/cookies";

export default function CategoryForm({ form, handleFinish }) {
  const [loading, setLoading] = useState(false);

  const normFile = useCallback((e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList || [];
  }, []);

  const beforeUpload = useCallback((file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      KoToast.error("You can only upload JPG/PNG file!");
      setLoading(false);
      // for antd Upload replacement
      return Upload.LIST_IGNORE || false;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      KoToast.error("Image must smaller than 2MB!");
      return Upload.LIST_IGNORE || false;
    }

    return true;
  }, []);

  const TextArea = ({ value, onChange }) => (
    <KoTextArea
      value={value}
      onChange={onChange}
      showCount
      maxLength={100}
    />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: null,
    colon: true,
    fields: [
      {
        key: "name",
        label: "Category Name",
        placeholder: "Ex: Tv, Mobile ...",
        colSpan: 4,
        rules: [
          {
            required: true,
            message: "Category name is required"
          }
        ]
      },
      {
        key: "description",
        label: "Description",
        placeholder: "Type product description here...",
        colSpan: 4,
        widget: TextArea
      }
    ]
  };

  const handleSubmit = useCallback(
    (values) => {
      handleFinish(values);
    },
    [handleFinish]
  );

  const uploadProps = {
    name: "files",
    multiple: true,
    accept: "image/*,video/*",
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: {
      service: getCookie("wos"),
      module: "taskplanner",
      lookupId: "lookupId"
    },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
    onChange(info) {
      setLoading(true);

      const { fileList } = info;

      const allFinished = fileList.every(
        (file) => file.status === "done" || file.status === "error"
      );

      if (allFinished) {
        setLoading(false);

        const successfulFiles = fileList
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            type: file.type,
            size: file.size,
            uid: file.uid,
            lastModifiedDate:
              file.lastModifiedDate || new Date().toISOString()
          }));

        console.log("successfulFiles", successfulFiles);
      } else if (info.file.status === "error") {
        setLoading(false);
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const uploadButton = (
    <div className={styles.dndArea}>
      {loading && <KoLoader size="small" />}
      <KoIcon name="ImagesOutlined" width={40} height={40} />
      <KoText
        className={styles.fileInfo}
        text="At least 115px x 30px PNG or JPG file"
      />
    </div>
  );

  return (
    <div className={styles.formWrapper}>
      <KoForm
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <KoForm.Item
          name="logo"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <ImgCrop
            aspect={115 / 25}
            cropShape="rect"
            restrictPosition
            showGrid={false}
            cropperProps={{
              cropSize: { width: 115, height: 25 },
              zoomWithScroll: false,
              showGrid: false
            }}
          >
            <Upload
              {...uploadProps}
              accept=".png, .jpg, .jpeg"
              className={styles.upload}
              beforeUpload={beforeUpload}
              maxCount={1}
              showUploadList={false}
              listType="picture-card"
            >
              {uploadButton}
            </Upload>
          </ImgCrop>
        </KoForm.Item>

        <div style={{ marginTop: "2rem" }} />

        <KoFormBuilder form={form} meta={meta} onFinish={handleSubmit}/>
      </KoForm>
    </div>
  );
}
